import React, { useEffect, useState } from 'react';

function Iframe(props) {
  const { src, width, height, children } = props;
  const [loading, setLoading] = useState(true);

  const iframe = React.createRef();

  const method = 'GET';
  const headers = new Headers({ ...props.headers });
  const options = { method, headers };

  const get = React.useRef(() => {});

  get.current = () => {
    fetch(src, options)
      .then((response) => response.text())
      .then((response) => {
        const frame =
          iframe.current.contentWindow || iframe.current.contentDocument.document || iframe.current.contentDocument;

        frame.document.open();
        frame.document.write(response);
        frame.document.close();
      });
  };

  useEffect(() => {
    get.current();
  }, []);

  return (
    <div className="d-flex flex-column" style={{ width, height }}>
      {loading ? children : null}
      <iframe
        src={src}
        ref={iframe}
        style={{ width: loading ? '0px' : '100%', height: loading ? '0px' : '100%' }}
        title="react-iframe"
        {...props}
        onLoad={() => setLoading(false)}
      />
    </div>
  );
}

export default Iframe;
